var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformanceRocket(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97264 15.0506C5.96249 18.081 1.92188 18.081 1.92188 18.081C1.92188 18.081 1.92187 14.0404 4.95233 13.0303",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 7.97938L10.0015 14.0403L5.96094 9.99968L12.0219 3.93877C14.3169 1.64375 16.6119 1.66614 17.5906 1.81217C17.7413 1.83463 17.8808 1.90491 17.9886 2.01265C18.0963 2.12039 18.1666 2.25989 18.1891 2.41059C18.3351 3.38935 18.3575 5.68436 16.0625 7.97938Z",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0508 8.99023V14.7553C15.0508 14.8491 15.0323 14.942 14.9964 15.0286C14.9605 15.1153 14.9079 15.194 14.8416 15.2604L11.9539 18.148C11.8625 18.2394 11.748 18.3043 11.6226 18.3358C11.4972 18.3672 11.3656 18.364 11.2418 18.3266C11.1181 18.2891 11.0068 18.2188 10.9199 18.123C10.833 18.0273 10.7738 17.9098 10.7484 17.783L10 14.041",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0076 4.94922H5.24257C5.14877 4.94922 5.05588 4.96769 4.96922 5.00359C4.88256 5.03949 4.80382 5.0921 4.73749 5.15843L1.84983 8.04608C1.75842 8.1375 1.69352 8.25202 1.66208 8.37742C1.63063 8.50283 1.63381 8.63441 1.67127 8.75815C1.70874 8.88189 1.77908 8.99314 1.87481 9.08004C1.97054 9.16693 2.08805 9.22622 2.21483 9.25158L5.95685 9.99998",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceRocket);
export default __webpack_public_path__ + "static/media/performance-rocket.aa03ed675edb3ccb742fde628d78dfc4.svg";
export { ForwardRef as ReactComponent };